import workflowTypes from './types';

const initialState = {
  workflows: [],
  page: 1,
  size: 10,
  fetchingWorkflows: false,
  savingWorkflow: false,
  deletingWorkflow: false,
  errorFetchingWorkflows: null,
  total: 0
};

function workflowsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case workflowTypes.FETCH_WORKFLOWS_REQUEST:
      return {
        ...state,
        fetchingWorkflows: true,
      };
    case workflowTypes.FETCH_WORKFLOWS_SUCCESS:
      return {
        ...state,
        workflows: payload.data,
        fetchingWorkflows: false,
        total: payload.resultTotal
      };
    case workflowTypes.FETCH_WORKFLOWS_FAILURE:
      return {
        ...state,
        fetchingWorkflows: false,
        errorFetchingWorkflows: payload,
      };

    case workflowTypes.CREATE_WORKFLOWS_REQUEST:
      return {
        ...state,
        savingWorkflow: true,
      };
    case workflowTypes.EDIT_WORKFLOWS_REQUEST:
      return {
        ...state,
        savingWorkflow: true,
      };

    case workflowTypes.CREATE_WORKFLOWS_SUCCESS:
      return {
        ...state,
        savingWorkflow: false,
      };
    case workflowTypes.CREATE_WORKFLOWS_FAILURE:
      return {
        ...state,
        savingWorkflow: false,
      };
    case workflowTypes.EDIT_WORKFLOWS_FAILURE:
      return {
        ...state,
        savingWorkflow: false,
      };

    case workflowTypes.DELETE_WORKFLOWS_REQUEST:
      return {
        ...state,
        deletingWorkflow: true,
      };

    case workflowTypes.DELETE_WORKFLOWS_SUCCESS:
    case workflowTypes.DELETE_WORKFLOWS_FAILURE:
      return {
        ...state,
        deletingWorkflow: false,
      };

    default:
      return state;
  }
}

export default workflowsReducer;
